import React, { useEffect, useState } from "react";
import { Formik, FieldArray, Field } from "formik";
import Swal from "sweetalert2";
import * as globalSettingsService from "../../../services/globalsetting.services";
import Breadcrums from "../../../common/breadcrumbs";
import {
  blockInvalidChar,
  handleServerValidations,
} from "../../../../../utils/commonfunction";
import { SWAL_SETTINGS } from "../../../../../utils/Constants";
import Loader from "../../../common/loader";
import { URL_REGEX, amountRegex, MOBILE_NUMBER_REGEX } from "../../../../../utils/Constants";
import { useTranslation } from "react-i18next";
import { Tooltip, Whisper } from "rsuite";

const GlobalSettings = (props) => {
  const { t } = useTranslation();
  const [showdefault, setShowDefault] = useState({});
  // const [ setContactNumber] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [submitClicked, setSubmitClicked] = useState(false);
  const [previewimage, setPreviewImage] = useState("");
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("sidebar_link_global_settings"), url: "" },
  ];

  useEffect(() => {
    globalSettingsService
      .Details()
      .then((response) => {
        setShowDefault(response && response.data ? response?.data : []);
        setPreviewImage(response?.data?.website_logo);
        // console.log("🚀 ~ .then ~ response:", response.data);
        setTimeout(() => {
          setDataLoaded(true);
        }, 100);
      })
      .catch((error) => {
        console.log("error=====>", error);
        setDataLoaded(true);
      });
  }, []);



  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (
        <Formik

          validateOnChange={true}
          enableReinitialize
          initialValues={{
            Address:
              showdefault && showdefault.address
                ? showdefault.address
                    .replace(/\r\n/g, "\n")
                    .replace(/\r/g, "")
                    .replace(/\u00D0/g, "")
                : "",
            // smtp_username:
            //   showdefault && showdefault.smtp_username
            //     ? showdefault.smtp_username
            //     : "",
            AdminEmail:
              showdefault && showdefault.admin_email
                ? showdefault.admin_email
                : "",
            contactEmail:
              showdefault && showdefault.contact_email
                ? showdefault.contact_email
                : "",
            financeEmail:
              showdefault && showdefault.finance_email
                ? showdefault.finance_email
                : "",
            Contact:
              showdefault && showdefault.phone_number
                ? showdefault.phone_number
                : "",
            CopyRighttxt:
              showdefault && showdefault.copy_right_text
                ? showdefault.copy_right_text
                : "",

            web: showdefault && showdefault.website ? showdefault.website : "",
            title: showdefault && showdefault.title ? showdefault.title : "",
            website_info: showdefault && showdefault.website_info ? showdefault.website_info : "",
            website_logo: showdefault && showdefault.website_logo ? showdefault.website_logo : "",
            // platform_commission: showdefault && showdefault.platform_commission ? showdefault.platform_commission : "",
            wallet_recharge_status: showdefault && showdefault.wallet_recharge_status ? showdefault.wallet_recharge_status : "false",
            recharge_gst: showdefault && showdefault.recharge_gst != null ? showdefault.recharge_gst : 0,
            // monthly_restaurant_enrollment_cost: showdefault && showdefault.monthly_restaurant_enrollment_cost ?
            //   showdefault.monthly_restaurant_enrollment_cost :
            //   "",
            // yearly_restaurant_enrollment_cost: showdefault && showdefault.yearly_restaurant_enrollment_cost ?
            //   showdefault.yearly_restaurant_enrollment_cost :
            //   "",
            socialMedia:
              showdefault && showdefault.social_media_details && showdefault?.social_media_details?.length
                ? showdefault.social_media_details.map((item) => ({
                    title: item.title || "",
                    link: item.link || "",
                    icon: item.icon || "",
                    image: item.image || "",
                  }))
                : [{ title: '', link: '', icon: '', image: '' }],
          }}
          validate={(values) => {
            const trimmed = (val) => (typeof val === "string" ? val.trim() : val);
            let error = { socialMedia: [] };
            // { console.log("values--",values.Address)}

            if (values?.socialMedia?.length > 0) {
              values?.socialMedia.forEach((element, i) => {
                error.socialMedia[i] = {};
                if (!element.title) {
                  error.socialMedia[i]["title"] = t("validation_err_title_required");
                } else if (element.title.length > 20) {
                  error.socialMedia[i]["title"] = t("validation_err_reached_maximum_length");
                }
                const hasIcon = Boolean(element.icon && String(element.icon).trim());
                const hasImage = Boolean(
                  element.image &&
                  (typeof element.image === "object" || String(element.image).trim())
                );
                if (!hasIcon && !hasImage) {
                  error.socialMedia[i]["icon"] = t("validation_err_icon_or_image_required");
                }
                if (hasIcon && element.icon.length > 150) {
                  error.socialMedia[i]["icon"] = t("validation_err_reached_maximum_length");
                }
                if (hasImage && typeof element.image === "object") {
                  const validFileTypes = ['image/jpg', 'image/jpeg', 'image/png', 'image/webp', 'image/gif', 'image/svg+xml'];
                  if (element.image.type && !validFileTypes.includes(element.image.type)) {
                    error.socialMedia[i]["image"] = t("supported_file_error");
                  }
                  if (element.image.size > 5 * 1024 * 1024) {
                    error.socialMedia[i]["image"] = t("image_max_size_error");
                  }
                }
                if (!element.link) {
                  error.socialMedia[i]["link"] = t("validation_err_link_required");
                } else if (element.link.length > 255) {
                  error.socialMedia[i]["link"] = t("validation_err_reached_maximum_length");
                } else if (!URL_REGEX.test(element.link)) {
                  error.socialMedia[i]["link"] = t("invalid_web_url")
                }
              });
            }
            if (error.socialMedia.length) {
              let socialMediaFlag = 0;
              error.socialMedia.forEach((element, i) => {
                if (Object.keys(element).length) {
                  socialMediaFlag++;
                }
              });
              if (!socialMediaFlag) {
                delete error.socialMedia;
              }
            } else {
              delete error.socialMedia;
            }

            // Admin Email
            if (!trimmed(values.AdminEmail)) {
              error.AdminEmail = t("label_email_error");
            } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(trimmed(values.AdminEmail))) {
              error.AdminEmail = t("invalid_email");
            }

            // Contact Email
            if (!trimmed(values.contactEmail)) {
              error.contactEmail = t("label_email_error");
            } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(trimmed(values.contactEmail))) {
              error.contactEmail = t("invalid_email");
            }

            // Finance Email
            if (!trimmed(values.financeEmail)) {
              error.financeEmail = t("label_email_error");
            } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(trimmed(values.financeEmail))) {
              error.financeEmail = t("invalid_email");
            }

            // Contact Number
            const contactStr = String(values.Contact || "").trim();
            if (!contactStr) {
              error.Contact = t("label_phone_number_required_error");
            } else if (!MOBILE_NUMBER_REGEX.test(contactStr)) {
              error.Contact = t("label_contact_invalid_error");
            }

            // Address
            const addressTrimmed = trimmed(values.Address);
            if (!addressTrimmed) {
              error.Address = t("label_location_error");
            } else if (addressTrimmed.length > 100) {
              error.Address = t("validation_err_reached_maximum_length"); // or custom: "Address must be max 100 characters"
            }

            // Website URL
            const webTrimmed = trimmed(values.web);
            if (!webTrimmed) {
              error.web = t("website_error");
            } else if (!URL_REGEX.test(webTrimmed)) {
              error.web = t("invalid_web_url");
            }

            // Copyright Text
            const copyrightTrimmed = trimmed(values.CopyRighttxt);
            if (!copyrightTrimmed) {
              error.CopyRighttxt = t("copyright_error");
            } else if (copyrightTrimmed.length > 200) {
              error.CopyRighttxt = "Copyright text must not exceed 200 characters";
            }

            // Website Title
            const titleTrimmed = trimmed(values.title);
            if (!titleTrimmed) {
              error.title = t("label_title_error");
            } else if (titleTrimmed.length > 50) {
              error.title = t("label_title_length_error_50");
            }

            // Website Info
            const infoTrimmed = trimmed(values.website_info);
            if (!infoTrimmed) {
              error.website_info = t("Website information is required");
            } else if (infoTrimmed.length > 150) {
              error.website_info = t("Exceed maximum length of 150");
            }
            if (!values.wallet_recharge_status || values.wallet_recharge_status === "false" || values.wallet_recharge_status === "true") {
              // Always valid since it's a select with only two options
            } else {
              error.wallet_recharge_status = "Please select a valid status";
            }

            if (values.recharge_gst === "" || values.recharge_gst === null || values.recharge_gst === undefined) {
              error.recharge_gst = "Recharge GST (%) is required";
            } else if (isNaN(values.recharge_gst) || Number(values.recharge_gst) < 0 || Number(values.recharge_gst) > 100) {
              error.recharge_gst = "Recharge GST must be between 0 and 100";
            }

            // Validate website logo image
            if (values.website_logo) {
              const image = values.website_logo;
              if (typeof image === 'string') {
                // Check if it's a URL (either HTTP or HTTPS)
                const urlRegex = /^(http|https):\/\/[^\s$.?#].[^\s]*$/gm;
                if (!urlRegex.test(image)) {
                  error.website_logo = t("invalid_image_url");
                }
              } else {
                // Check file type (JPG, JPEG, PNG, WEBP, GIF)
                const validFileTypes = ['image/jpg', 'image/jpeg', 'image/png', 'image/webp', 'image/gif'];
                if (!validFileTypes.includes(image.type)) {
                  error.website_logo = t("supported_file_error");
                }

                // Check file size (max 1.5MB)
                if (image.size > 5 * 1024 * 1024) {
                  error.website_logo = t("image_max_size_error");
                }
              }
            } else {
              error.website_logo = t("image_required_error");
            }

            return error;
          }}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            setSubmitted(true);
            let formData = new FormData();
            formData.append(
              "address",
              values.Address
                ? values.Address
                    .replace(/\r\n/g, "\n")
                    .replace(/\r/g, "")
                    .replace(/\u00D0/g, "")
                    .split("\n")
                    .map((l) => l.trim())
                    .join("\n")
                    .trim()
                : ""
            );
            formData.append("website", values.web);
            // formData.append("smtp_username", values.smtp_username);
            formData.append("admin_email", values.AdminEmail);
            formData.append("contact_email", values.contactEmail);
            formData.append("finance_email", values.financeEmail);
            const socialMediaPayload = (values.socialMedia || []).map((item, index) => {
              if (item.image instanceof File) {
                formData.append(`social_image_${index}`, item.image);
              }
              return {
                title: item.title || "",
                link: item.link || "",
                icon: item.icon || "",
                image:
                  typeof item.image === "string"
                    ? item.image
                    : showdefault?.social_media_details?.[index]?.image || "",
              };
            });
            formData.append("social_media_details", JSON.stringify(socialMediaPayload));
            formData.append("phone_number", values.Contact);
            formData.append("copy_right_text", values.CopyRighttxt);
            formData.append("title", values.title);
            formData.append("website_info", values.website_info);
            formData.append("website_logo", values.website_logo);
            // formData.append("platform_commission", values.platform_commission);
            formData.append("wallet_recharge_status", values.wallet_recharge_status);
            formData.append("recharge_gst", values.recharge_gst !== "" ? values.recharge_gst : 0);
            // formData.append("monthly_restaurant_enrollment_cost", values.monthly_restaurant_enrollment_cost);
            // formData.append("yearly_restaurant_enrollment_cost", values.yearly_restaurant_enrollment_cost);
            // console.log("formData--->",formData)
            globalSettingsService
              .Add(formData)
              .then((response) => {
                if (response.success) {
                  Swal.fire({
                    icon: "success",
                    text: response.message,
                    ...SWAL_SETTINGS,
                  });
                  setTimeout(() => {
                    setSubmitted(false);
                  }, 2000);
                } else {
                  Swal.fire({
                    icon: "error",
                    text: handleServerValidations(response),
                    ...SWAL_SETTINGS,
                  });
                  setSubmitted(false);
                }
              })
              .catch((error) => {
                console.log("error ====> ", error);
              });
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting,
            setFieldTouched,
          }) => (
            <form onSubmit={handleSubmit}>
              {console.log("values", values)}
              {console.log("error", errors)}
              <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                  <div className="card custom-card">
                    <div className="card-body">
                      <div>
                        <h6 className="main-content-label mb-3">
                          {t("sidebar_link_global_settings")}
                        </h6>
                      </div>
                      <div className="row row-sm">
                        {/* <div className="col-md-12 text-center form-group">
                          <label
                            htmlFor="smtp_username"
                            className="text-left d-flex"
                          >
                            SMTP {t("label_username")}:<span className="requirestar">*</span>
                          </label>
                          <input
                            name="smtp_username"
                            type="text"
                            id="smtp_username"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.smtp_username}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.smtp_username &&
                              touched.smtp_username &&
                              errors.smtp_username}
                          </span>
                        </div> */}
                        <div className="col-md-12 text-center form-group">
                          <label
                            htmlFor="AdminEmail"
                            className="text-left d-flex"
                          >
                            {t("role_super_admin")} {t("label_email")}:<span className="requirestar">*</span>
                          </label>
                          <input
                            name="AdminEmail"
                            type="text"
                            id="AdminEmail"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.AdminEmail}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.AdminEmail &&
                              touched.AdminEmail &&
                              errors.AdminEmail}
                          </span>
                        </div>
                        
                        <div className="col-md-12 text-center form-group">
                          <label
                            htmlFor="contactEmail"
                            className="text-left d-flex"
                          >
                            {t("Contact Email")}:<span className="requirestar">*</span>
                          </label>
                          <input
                            name="contactEmail"
                            type="text"
                            id="contactEmail"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.contactEmail}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.contactEmail &&
                              touched.contactEmail &&
                              errors.contactEmail}
                          </span>
                        </div>
                        
                        <div className="col-md-12 text-center form-group">
                          <label
                            htmlFor="financeEmail"
                            className="text-left d-flex"
                          >
                            {t("Finance Email")}:<span className="requirestar">*</span>
                          </label>
                          <input
                            name="financeEmail"
                            type="text"
                            id="financeEmail"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.financeEmail}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.financeEmail &&
                              touched.financeEmail &&
                              errors.financeEmail}
                          </span>
                        </div>
                        
                        <div className="col-md-12 text-center form-group">
                          <label
                            htmlFor="Contact"
                            className="text-left d-flex"
                          >
                            {t("label_contact_no")}:<span className="requirestar">*</span>
                          </label>
                          <input
                            name="Contact"
                            type="text"
                            id="Contact"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.Contact}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.Contact &&
                              touched.Contact &&
                              errors.Contact}
                          </span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="Address" className="text-left d-flex">
                            {t("list_heading_address")}:<span className="requirestar">*</span>{" "}
                          </label>
                          <textarea
                            name="Address"
                            id="Address"
                            type="text"
                            style={{ minHeight: "100px" }}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.Address}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.Address &&
                              touched.Address &&
                              errors.Address}
                          </span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="web" className="text-left d-flex">
                            {t("label_website")}:<span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="web"
                            id="web"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.web}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.web && touched.web && errors.web}
                          </span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label
                            htmlFor="CopyRighttxt"
                            className="text-left d-flex"
                          >
                            {t("label_copy_right_text")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="CopyRighttxt"
                            type="text"
                            id="CopyRighttxt"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.CopyRighttxt}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.CopyRighttxt &&
                              touched.CopyRighttxt &&
                              errors.CopyRighttxt}
                          </span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label
                            htmlFor="title"
                            className="text-left d-flex"
                          >
                            {t("Website title")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="title"
                            type="text"
                            id="title"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.title}
                            className="form-control"
                            placeholder="Website title"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.title &&
                              touched.title &&
                              errors.title}
                          </span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label
                            htmlFor="website_info"
                            className="text-left d-flex"
                          >
                            {t("Website Info")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="website_info"
                            type="text"
                            id="website_info"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.website_info}
                            className="form-control"
                            placeholder="Website info"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.website_info &&
                              touched.website_info &&
                              errors.website_info}
                          </span>
                        </div>

                        <div className="col-lg-6 text-center form-group">
                          <label htmlFor="website_logo" className="text-left d-flex">
                            {t("Website Logo")}:
                            {" "}
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>
                                  {t("image_support_tooltip")}
                                </Tooltip>
                              }
                            >
                              <span className="field-more-info mt-1 ms-1 cp">
                                ?
                              </span>
                            </Whisper>
                          </label>
                          <input
                            className="form-control imgInput"
                            id="website_logo"
                            name="website_logo"
                            accept="image/*"
                            type="file"
                            onChange={(event) => {
                              setFieldValue(
                                "website_logo",
                                event.target.files[0] || ""
                              );
                              event.target.files.length === 1
                                ? setPreviewImage(
                                  URL.createObjectURL(event.target.files[0])
                                )
                                : setPreviewImage("");
                            }}
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.website_logo &&
                              touched.website_logo &&
                              errors.website_logo}
                          </span>
                          {previewimage ? (
                            <ul className="question-image-preview questions-ul">
                              <li className="pr_img_box">
                                <img
                                  src={previewimage}
                                  style={{ height: "100px" }}
                                  alt={"profileImg"}
                                />
                              </li>
                            </ul>
                          ) : (
                            ""
                          )}
                        </div>

                         {/* <div className="col-md-6 text-center form-group">
                          <label
                            htmlFor="platform_commission"
                            className="text-left d-flex"
                          >
                            Platform Commission (%):
                            <span className="requirestar">*</span>{" "}
                          </label>

                          <div className="input-group mb-3">
                            
                            <input
                              name="platform_commission"
                              type="number"
                              id="platform_commission"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.platform_commission}
                              className="form-control"
                              onKeyDown={blockInvalidChar}
                            />
                            <div className="input-group-prepend">
                              <span className="input-group-text">%</span>
                            </div>
                          </div>
                          <span className="text-danger d-flex text-left">
                            {errors.platform_commission &&
                              touched.platform_commission &&
                              errors.platform_commission}
                          </span>
                        </div> */}

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="wallet_recharge_status" className="text-left d-flex">
                            {t("Wallet recharge status")}:
                            <span className="requirestar">*</span>
                          </label>
                          <div className="select-down-arrow">
                            <select
                              name="wallet_recharge_status"
                              id="wallet_recharge_status"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={String(values.wallet_recharge_status)}
                              className="form-control"
                            >
                              <option value="false">{t("False")}</option>
                              <option value="true">{t("True")}</option>
                            </select>
                          </div>
                          <span className="text-danger d-flex text-left">
                            {errors.wallet_recharge_status &&
                              touched.wallet_recharge_status &&
                              errors.wallet_recharge_status}
                          </span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label
                            htmlFor="recharge_gst"
                            className="text-left d-flex"
                          >
                            {t("Wallet Recharge GST (%)")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <div className="input-group mb-3">
                            <input
                              name="recharge_gst"
                              type="number"
                              id="recharge_gst"
                              min="0"
                              max="100"
                              step="0.01"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.recharge_gst}
                              className="form-control"
                              placeholder="e.g. 10"
                              onKeyDown={blockInvalidChar}
                            />
                            <div className="input-group-prepend">
                              <span className="input-group-text">%</span>
                            </div>
                          </div>
                          <span className="text-danger d-flex text-left">
                            {errors.recharge_gst &&
                              touched.recharge_gst &&
                              errors.recharge_gst}
                          </span>
                        </div>


                        {/*<div className="col-md-12 text-center form-group">
                          <label
                            htmlFor="yearly_restaurant_enrollment_cost"
                            className="text-left d-flex"
                          >
                            {t("yearly_enrollement_cost")}:
                            <span className="requirestar">*</span>{" "}
                          </label>

                          <div className="input-group mb-3">
                            <div className="input-group-prepend">
                              <span className="input-group-text">¥</span>
                            </div>
                            <input
                              name="yearly_restaurant_enrollment_cost"
                              type="text"
                              id="yearly_restaurant_enrollment_cost"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.yearly_restaurant_enrollment_cost}
                              className="form-control"
                            />
                          </div>
                          <span className="text-danger d-flex text-left">
                            {errors.yearly_restaurant_enrollment_cost &&
                              touched.yearly_restaurant_enrollment_cost &&
                              errors.yearly_restaurant_enrollment_cost}
                          </span>
                        </div> */}

                        {/* ---- */}

                        <label className="text-left d-flex">
                          {t("label_social_media")}:
                        </label>
                        <p className="text-muted text-left mb-2">
                          {t("social_icon_or_image_help")}
                        </p>
                        <FieldArray
                          name="socialMedia"
                          render={(arrayHelper) => (
                            <div className="mb-4">
                              {values?.socialMedia &&
                                values?.socialMedia?.length >= 0 ? (
                                values?.socialMedia.map((item, index) => {
                                  const imagePreview =
                                    item.image && typeof item.image === "string"
                                      ? item.image
                                      : item.image
                                        ? URL.createObjectURL(item.image)
                                        : "";
                                  const showError = (field) =>
                                    ((touched.socialMedia &&
                                      touched.socialMedia[index] &&
                                      touched.socialMedia[index][field]) ||
                                      submitClicked) &&
                                    errors.socialMedia &&
                                    errors.socialMedia[index] &&
                                    errors.socialMedia[index][field];
                                  return (
                                    <div className="social-media-card" key={index}>
                                      <div className="d-flex flex-wrap align-items-end" style={{ gap: "10px" }}>
                                        <div style={{ width: "140px" }}>
                                          <label className="social-field-label">{t("input_placeholder_title")}</label>
                                          <Field
                                            className="form-control form-control-sm"
                                            id={`social_title_${index}`}
                                            name={`socialMedia[${index}].title`}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={item.title}
                                            placeholder={t("input_placeholder_title")}
                                          />
                                          <span className="text-danger d-flex text-left small">{showError("title")}</span>
                                        </div>
                                        <div style={{ width: "220px" }}>
                                          <label className="social-field-label">{t("input_placeholder_link")}</label>
                                          <Field
                                            className="form-control form-control-sm"
                                            id={`social_link_${index}`}
                                            name={`socialMedia[${index}].link`}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={item.link}
                                            placeholder={t("input_placeholder_link")}
                                          />
                                          <span className="text-danger d-flex text-left small">{showError("link")}</span>
                                        </div>
                                        <div style={{ width: "240px" }}>
                                          <label className="social-field-label">{t("input_placeholder_icon")}</label>
                                          <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                                            <Field
                                              className="form-control form-control-sm"
                                              id={`social_icon_${index}`}
                                              name={`socialMedia[${index}].icon`}
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              value={item.icon}
                                              placeholder={'<i class="ri-instagram-fill"></i>'}
                                            />
                                            {item.icon ? (
                                              <span
                                                className="social-preview"
                                                dangerouslySetInnerHTML={{ __html: item.icon }}
                                              />
                                            ) : null}
                                          </div>
                                          <span className="text-danger d-flex text-left small">{showError("icon")}</span>
                                        </div>
                                        <div>
                                          <label className="social-field-label">{t("label_social_image")}</label>
                                          <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                                            <input
                                              className="form-control form-control-sm"
                                              id={`social_image_${index}`}
                                              name={`socialMedia[${index}].image`}
                                              accept="image/*"
                                              type="file"
                                              onChange={(event) => {
                                                setFieldValue(
                                                  `socialMedia[${index}].image`,
                                                  event.target.files[0] || item.image || ""
                                                );
                                              }}
                                            />
                                            {imagePreview ? (
                                              <span className="social-preview">
                                                <img src={imagePreview} alt={item.title || "social"} />
                                              </span>
                                            ) : null}
                                          </div>
                                          <span className="text-danger d-flex text-left small">{showError("image")}</span>
                                        </div>
                                        <div className="social-media-action mb-1">
                                          <button
                                            className="btn btn-sm btn-danger"
                                            type="button"
                                            disabled={values?.socialMedia?.length === 1}
                                            onClick={() => arrayHelper.remove(index)}
                                          >
                                            {t("link_remove")}
                                          </button>
                                          {index === values?.socialMedia?.length - 1 && (
                                            <button
                                              className="btn btn-sm btn-main-primary signbtn"
                                              type="button"
                                              onClick={() =>
                                                arrayHelper.insert(values?.socialMedia?.length, {
                                                  title: "",
                                                  link: "",
                                                  icon: "",
                                                  image: "",
                                                })
                                              }
                                            >
                                              {t("link_add")}
                                            </button>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })
                              ) : (
                                <button
                                  className="btn btn-main-primary signbtn mr-2 ms-2 mb-3"
                                  type="button"
                                  onClick={() => arrayHelper.push({ title: "", link: "", icon: "", image: "" })}
                                >
                                  Add a social media
                                </button>
                              )}
                            </div>
                          )}
                        />


                        {/* {hasPermission("/admin/cms/settings/submit") ? ( */}
                        <div className="">
                          <button
                            className="btn btn-main-primary signbtn mr-2"
                            type="submit"
                            disabled={submitted ? true : null}
                            onClick={() => {
                              setSubmitClicked(true);
                            }}
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_submit")}
                          </button>
                        </div>
                        {/* ) : null} */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default GlobalSettings;


